import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ConversationService } from '../../../../core/src/lib/conversation.service';
import { ConversationDetail } from '../../../../core/src/lib/interface/conversation.interface';
import { ReplaySubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'inbox-conversation-preview',
  templateUrl: './inbox-conversation-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InboxConversationPreviewComponent {
  private readonly conversationService = inject(ConversationService);
  private readonly conversationDetail$$ = new ReplaySubject<ConversationDetail>(1);
  private readonly conversationDetail$ = this.conversationDetail$$.asObservable();
  protected readonly previewContent$ = this.conversationDetail$.pipe(
    switchMap((details) => this.conversationService.getPreviewContent(details)),
  );

  @Input() set conversationDetail(value: ConversationDetail) {
    this.conversationDetail$$.next(value);
  }
}
